import store from '../store'

export default {
  getCurrentDateTime(){
    var date = new Date();
    var nowUTC =  Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
    date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());

    return new Date(nowUTC);
  },

  getUnixCurrentDateTime(){
    return Math.floor(this.getCurrentDateTime().getTime() / 1000);
  },

  formatDateTime(dateTime) {
    let date = new Date(dateTime);
    let dateStr =  date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
            ("00" + date.getHours()).slice(-2) + ":" +
            ("00" + date.getMinutes()).slice(-2) + ":" +
            ("00" + date.getSeconds()).slice(-2);

    return dateStr
  },

  removeTimeTZ(time){
    return time.toLocaleString().replace('T', ' ').replace('Z', ' ');
  },

  getLocalDateTime(){
    return new Date().toLocaleString("en-US",Intl.DateTimeFormat().resolvedOptions().timeZone);
  },

  getTokenRemainingTime(){
    if (store.state.auth == null){
      return;
    }

    let tokenExp = '';
    let now = this.getLocalDateTime();

    if (store.state.auth.tokenExpiry != null) {
      tokenExp = process.env.NODE_ENV == 'development' ? this.removeTimeTZ(store.state.auth.tokenExpiry) : store.state.auth.tokenExpiry;
    }

    // get token expiry value, then convert it to user local time and subtract current date time
    tokenExp = Math.round(new Date(this.convertDatetimeByTimezone(this.formatDateTime(tokenExp))) - new Date(this.formatDateTime(now)));

    return tokenExp;
  },

  convertDatetimeByTimezone(dateTime) {
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (dateTime == null){
        return "";
    }

    return new Date((typeof dateTime === "string" ? new Date(dateTime) : dateTime).toLocaleString("en-US", {timeZone: timezone}));
  },

  isValidDomain(v) {
    if (!v) return false;
    var re = /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/gi;
    return re.test(v);
  },

  parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  },

  getTokenParam(){
    var url = new URL(window.location);
    var email = url.searchParams.get("token");

    return email;
  },

  getRedirectURL(){
    var url = new URL(window.location);
    var redirectURL = url.searchParams.get("redirect_url");

    return redirectURL;
  },

  setOrganisationID() {
    return store.state.auth.isSuperAdmin || this.isVertexAnalyst() ? store.state.user.organisation.id : store.state.user.organisation.organisation_id;
  },

  checkUserRole(products, role){
    var isExist = false
    products.forEach(product => {
        if (product.roles.includes(role))
          isExist = true
    });

    return isExist
  },

  checkRole(products, product,role){
    var isExist = false
    products.forEach(v => {

      if (product == v.product) {
        if (v.roles.includes(role))
          isExist = true
      }
    });

    return isExist
  },

  limitString(str, len){
    if (str == null || str == "")
      return "";

    if (str.length > len)
      return str.substring(0, len) + '...';

    return str.substring(0, len);
  },

  isVertexAnalyst (){
    return store.state.auth.accessType == "vertex_analyst"
  },

  isUserAdmin() {
    if (!store.state.user.organisation.products) return

    let products = this.isVertexAnalyst() ? store.state.user.organisation.products[0] : store.state.user.organisation.products

    for (const product of products) {
      if (product.roles.includes("admin") == true) {
        return true
      }
    }

    return false
  },

  settingsAdmin() {
    if (!store.state.user.organisation.products) return
    let products = this.isVertexAnalyst() ? store.state.user.organisation.products[0] : store.state.user.organisation.products

    for (const product of products) {
      if (product.product === 'email_compromise_check' || product.product === 'training' || product.product === 'phishing') {
        if (product.roles.includes("admin") == true)
          return true
      }
    }
    return false
  },

  trainingAdmin() {
    if (!store.state.user.organisation.products) return false

    if (store.state.user.organisation.is_organisation_admin) return true

    let products = this.isVertexAnalyst() ? store.state.user.organisation.products[0] : store.state.user.organisation.products

    for (const product of products) {

      if (product.product === 'training') {
        if (product.roles.includes("admin") == true)
          return true
      }
    }

    return false
  },

  truncateLongText(fullStr, strLenLimit, separator = "...") {
    if (fullStr.length <= strLenLimit) return fullStr;

    const sepLen = separator.length;
    const charsToShow = strLenLimit - sepLen;

    return fullStr.substr(0, charsToShow).trim() + separator;
  },

  getErrorMessage(error) {
    if (error.isAxiosError) {
      if (error.response) {
        // Check if the error response has a message
        return error.response.data.message || error.response.statusText || 'An error occurred';
      } else if (error.request) {
        // No response received
        return 'No response received from server';
      }
    }
    // Handle non-Axios errors
    return error.message || 'An unexpected error occurred';
  }
}